import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

/**
 * Blade 1: catalog of available groupings. Click an item to add it to the
 * Selected blade. Items already in Selected are dimmed and non-clickable.
 *
 * Mirrors the column-builder's CatalogPanel pattern, but groupings are a
 * fixed flat list (no categories), so this is simpler than the column
 * variant.
 */
export default function GroupingCatalogPanel ({ available, onAdd, classes }) {
  return (
    <div className={classes.catalogPanel}>
      <div className={classes.panelHeader}>Available Groupings</div>
      <div className={classes.catalogList}>
        {available.map(opt => (
          <div
            key={opt.value}
            className={clsx(classes.catalogItem, { [classes.catalogItemAdded]: opt.alreadyAdded })}
            onClick={opt.alreadyAdded ? undefined : () => onAdd(opt.value)}
            role='button'
            tabIndex={opt.alreadyAdded ? -1 : 0}
            aria-disabled={opt.alreadyAdded ? 'true' : undefined}
            onKeyDown={(e) => {
              if (opt.alreadyAdded) return
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault()
                onAdd(opt.value)
              }
            }}
          >
            {opt.label}
          </div>
        ))}
      </div>
    </div>
  )
}

GroupingCatalogPanel.propTypes = {
  available: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    alreadyAdded: PropTypes.bool
  })).isRequired,
  onAdd: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired
}
